<template>
    <div class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>成品出库-汇总</div> 
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>成品出库-明细</div> 
            </div>
        </div>
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <out-two></out-two>
        </div>
        <div v-show="actitem=='one'" style=" background:white;line-height:30px;border-bottom:2px solid #389">
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:70px;line-height:30px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;font-weight:600">新增 </span></el-link>
                </div>
                <el-checkbox border size="small"  @change="selChg"  v-model="v_sel" true-label="Y"  false-label="N"><span style="font-size:12px;color:#389;margin-right:5px">全选</span></el-checkbox>  
                <span style=" font-size:12px;margin-right:10px;margin-left:10px;">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:150px; " >
                    <span v-for="item in stkCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input> 
                <el-button type="danger"   icon="iconfont icon-daochu" @click="nextGen" size="mini" style="margin-left:15px;height:30px;margin-top:1px">下推应收单</el-button>
            </div>
        </div>  
        <el-table v-show="actitem=='one'" :data="outData"
              border                            
              size="small"
              :cell-style="{padding:'4px','font-size':'12px',color:'black'}"
              v-loading="t_loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              show-summary
              :summary-method="getStkSum"
              ref="refstk"
              highlight-current-row
              header-cell-class-name="clearPadding"
              :header-cell-style="{ 'color':'#389','text-align':'center'}"
              class="custom-table-border"
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60" fixed>
                <template slot="header"  >
                    <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                        <el-tooltip content=" 清除条件" effect="light">
                            <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                        </el-tooltip>
                    </el-link>
                </template>
            </el-table-column>    
            <el-table-column  v-for="(item ,index) in stkCol.filter(item=>item.thide=='N')" :key="index"  
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"   show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <!-- <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  -->
                        <el-select v-if="item.key=='STFG'" v-model="v_row[item.key]"  size="mini" @change="inputQry" placeholder="请选择"  clearable style="width:100%">
                            <el-option label="否" value="N"></el-option>
                            <el-option label="是" value="Y"></el-option>
                        </el-select>  
                        <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  placeholder="数字框" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.key=='SEL'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark"  style="text-align:center">是</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark"  style="text-align:center">否</el-tag>  
                        <el-checkbox v-else-if="item.key=='SEL'" :disabled="!!scope.row['ARNO'] ||scope.row['STFG']=='N'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-checkbox v-else-if="item.edcss=='checkbox'"  disabled  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]" style="float:left"></span>
                    </template>
                </el-table-column>
            </el-table-column> 
             <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="210">
                <template slot-scope="scope">
                    <!-- <span v-if="scope.row.STFG==='Y'" >
                        <i class="iconfont icon-xiashuangjiantou" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="nextGen(scope.row,scope.$index )" :disabled="!!scope.row['ARNO']" :underline="false"  ><span style="font-size:12px;margin-right:5px;">下推应收</span></el-link>
                    </span> -->
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看 </span></el-link>  
                    <span v-if="scope.row.STFG==='N'" >
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="editRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">编辑 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N'" >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y'" >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N'" >
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'X',scope.$index)" :underline="false"  ><span style="font-size:12px; ">作废</span></el-link>
                    </span>  
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div v-show="actitem=='one'" style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="formRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in stkCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="formRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="formRow[item.key]" style="width:100%" ></el-input-number>   
         
                            <el-select size="medium" v-else-if="item.edcss==='select'" v-model="formRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="formRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar">
                    <span class="spanRow"> 出库明细</span>
                    <el-button :disabled="saveFlag" @click="refSent" type="primary" plain size="mini" style="height:28px;margin-top:2px;margin-left:20px;border:1px solid green">
                        <i class="iconfont  icon-icon-choose" style=" font-size:12px;margin-right:3px"></i>选择发货通知单
                    </el-button> 
                
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    style="margin-top:-8px"
                    ref="refdtl"
                    v-loading="v_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    show-summary
                    :summary-method="getSummary"
                    :cell-style="{padding:'4px','font-size':'12px',color:'black'}"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="getRowClick"
                    highlight-current-row > 
                    <el-table-column label="序号" width="60" type="index"></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                        <template slot-scope="scope"> 
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='STKNO'" >{{scope.row['STKNM']}}</span>
                                <el-input size="mini"  v-else-if="item.key=='MATNO'" disabled v-model="scope.row[item.key]" style="width:100%"> 
                                    <template v-if="scope.row['STFG']=='C'" slot="suffix" > <el-link    :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" style="color:red" ></i></el-link></template>
                                </el-input> 
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]"  > </el-input>                                             
                                <el-select :ref="scope.$index+item.key"  size="mini" v-else-if="item.edcss=='select'"  filterable v-model="scope.row[item.key]"  > 
                                    <el-option v-for="(it,index) in comboArr[item.key]" :key="index" :label="it.CNAME" :value="it.CODE"></el-option>
                                </el-select> 
                         
                                <el-input size="mini"  v-else-if="item.key=='MATNO'" readonly   v-model="scope.row[item.key]" style="width:100%"> 
                                    <template v-if="scope.row['STFG']=='C'" slot="suffix" > <el-link  @click="inputBtn(scope.row,scope.$index)" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" style="color:red" ></i></el-link></template>
                                </el-input> 
                                <el-select @change="modelChange"  v-else-if="item.key==='TAX'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <span v-for="item in taxArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                    </span>
                                </el-select>
 
                                <el-date-picker v-else-if="item.edcss=='date2'" :clearable="false" value-format="yyyy-MM-dd" type="date" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )"  size="mini" v-model="scope.row[item.key]"   > </el-date-picker>     
                                <el-input  v-else-if="item.disabled=='N'"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" size="mini" v-model="scope.row[item.key]"  > </el-input>                                      
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template>
                    </el-table-column>    
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="170">
                        <template slot-scope="scope">
                            <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="cpRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">复制行</span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">删除</span></el-link>
                            <i class="iconfont icon-chakan-copy" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="qryStkLog(scope.row )" :underline="false"  ><span style="font-size:12px;margin-right:1px;">查库存</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >  
                <span style="float:right">            
 
                <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
 
        </el-dialog>
 
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-one v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" v-bind:v_cond="t_cond" @child-sure="btnSure"></pub-one>                
        </el-dialog> 
        <!-- 查看库存 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="logWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">库存日志</span>
            </div> 
            <div style="height:92vh;overflow-y:auto"><stklog v-bind:toolFlag="toolFlag"  v-bind:v_cond="qryCond"></stklog></div>
        </el-dialog>
        <!-- 销售订单 -->
        <el-dialog  :visible.sync="saleWin" v-if="saleWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">请选择</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <pub-ord v-bind:v_cond="v_cond" v-bind:tabCol ="tableCol" v-bind:v_table="v_table"   @child-sure="saleOk" @child-exit="saleWin=false"></pub-ord>
            </div>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
    
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import outTwo from './sale_out_two.vue'
 
import pubOrd from '../datamgt/pubmulti.vue' 
import pubOne from '../datamgt/pub_easy_one.vue' 
import stklog from './prd_stklog.vue'
import repWin from '../datamgt/repWin.vue' 
export default {
    name:'sale_outstk2',
    data () {
        return {
            v_sel:'N',
            v_cond:'',
            saleWin:false,
            toolFlag:false,
            qryCond:'',
            logWin:false,
            dtlRow:{},
            v_commit :true,
            stfgBool:true,
            btnWin:false,
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            cltWin:false,
            selPrdWin:false,
            notNull:[],
            promptWin:false,
            v_random:'',
            prdRow:{},
            stkCol:[],
            v_tabRow:{},
            sentCol:[],
            rowDtl:{},
            delPrdArr:[],
            v_row:{},
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            actitem:'one',
            selparam:'IDNO',
            txtparam:'',
 
            formRow:{},
            prdFlag:'create',
            goPage:'',
 
            outData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            t_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            v_loading:false,
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany',
            options: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            logCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            clntArr:[],
            v_idseq:this.$cookies.get('idseq'),
            t_cond:'',
            matWin:false,
            comboArr:[],
            taxArr:[],
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_key:'',
            chkIndex:'',
            v_tabIndex:'',
        }
    },
    components: {
      outTwo,  //注册组件
  
      stklog,
      pubOne,
      pubOrd,
      repWin,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 192) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 250) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    mounted () {
        this.showkey()
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','124','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
 
        //税率
        getBaseData(this.v_url,'parentno','249' ,'','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','124','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','124','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getStkList('')  
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        selChg(){
            if (this.v_sel =='Y'){
                this.outData.filter(item=>item.STFG=='Y').filter(item=>!item['ARNO']).forEach((item,index)=>{
                    item['SEL'] ='Y' 
                })
            }else{
                this.outData.filter(item=>item.STFG=='Y').forEach((item,index)=>{
                    item['SEL'] ='N' 
                })
            }            
        },
        nextGen(){
            const v_len =this.outData.filter(item=>item['SEL']=='Y').length
            if (v_len ==0){
                this.promptWin =true
                this.prompt ='请选择要下推的记录'
            }else{
                this.$confirm( '你确定要下推生成销售应收单吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    
                    let v_idseqArr =this.outData.filter(item=>item['SEL']=='Y').map(item=>Object.assign({IDSEQ:item.IDSEQ}))
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/mrp_Calc',
                        data: {p_json:JSON.stringify(v_idseqArr), corpid:this.v_corpid, p_action:'RECEIVE' },
                    }).then(res=>{ 
                        if (res.code=='200'){        
                            this.$notify({
                                title: '成功',
                                message: '已成功下推销售应收单，请到销售应收单界面中查看' ,
                                type: 'success'
                            })
                            this.getStkList('') 
                        }else{
                            this.promptWin =true
                            this.prompt ='下推失败！'+res.result
                        }
                    })
    
                }).catch(err=>{})
            }
        },
        itemClick(val){
            this.actitem =val     
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getStkList('')
        } ,
        //字段查询
        inputQry(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.stkCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }
                }
            })
            this.getStkList(v_cond+cond_)
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val ){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    v_count =this.dtlData.length                 
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    this.$refs[ this.chkIndex+'ACTQTY'][0].focus()  
                }else{
                    let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox'&&item.key!=='TAX')
                    v_col.some((item,index)=>{
                        if (item.key==key){
                            this.$refs[ this.chkIndex+ v_col[index+1].key][0].focus()  
                        }
                    })
                } 
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1       
                if (this.chkIndex >=this.dtlData.length) {
                    this.chkIndex =0
                }
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])           
                this.$refs[this.chkIndex+key][0].focus()             
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }                            
                this.$refs[ this.chkIndex+key][0].focus()  
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])       
            }                    
        },
        getRowClick(row){
            this.chkIndex =row.index
        },
        btnSure(obj){
            let v_one=obj[0]
            this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{MATTYNM:v_one['MATTYNM'],MATNO:v_one['MATNO'],MATNM:v_one['MATNM'],MATDESC:v_one['MATDESC'],UNITNM:v_one['UNITNM']} ))
            this.btnWin =false
        },
 
        modelChange(){
            this.$forceUpdate()
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT' ||column.property==='ACTQTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        getStkSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =this.allList.map(item=>Number(item[column.property]));
                if(column.property==='AMT' ||column.property==='OUTQTY2'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['MATTY'] ='PRD'
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                if (this.v_corpid=='300'){
                    if (row['REPNO']=='sale_pay_prc.cpt'){
                        this.repUrl =this.$store.state.repUrl+ 'sale_pay_prc_jx.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
                    }else{
                        this.repUrl =this.$store.state.repUrl+ 'sale_pay_jx.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
                    }
                }else{
                    this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
                }
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        //销售订单选择
        saleOk(data_){
            if (data_.length>0){ //IDNO,MATNM,MATDESC,MODELNM,MATTYNM,PRC,TTLAMT,QTY ::TAXPRC,AMT
                for(let k=0;k<data_.length;k++){
                    let v_bool =true
                    this.dtlData.some(item=>{
                        if (item['REFIDSEQ']==data_[k].IDSEQ && item['REFLSTSEQ']==data_[k].LSTSEQ){
                            v_bool =false
                        }
                    })
                    if (v_bool){
                        let obj_={}
                        Object.assign(obj_,{MATNO:data_[k].MATNO,MATNM:data_[k].MATNM,MATDESC:data_[k].MATDESC,IDSEQ:'',LSTSEQ:'',STKNO:data_[k]['STKNO'],STKNM:data_[k]['STKNM'],OUTLSTSEQ:data_[k].LSTSEQ,
                        POQTY:data_[k].ORDQTY, ACTQTY:data_[k].QTY,REFIDNO:data_[k].ORDNO,REFIDSEQ:data_[k].REFIDSEQ,REFLSTSEQ:data_[k].REFLSTSEQ,UNITNM:data_[k]['UNITNM'],TAXPRC:data_[k]['PRC'],
                        CLTORDNO:data_[k]['CLTORDNO'],ORDCLNTNM:data_[k]['CLNTNM'],TAX:data_[k]['TAX'],MATTYNM:data_[k]['MATTYNM'],OUTQTY:data_[k].QTY,OUTNO:data_[k].IDNO,OUTIDSEQ:data_[k].IDSEQ} )
                        this.dtlData.push(obj_)
                    }
                }   
            }
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
            this.saleWin=false
        },
        //查看库存
        qryStkLog(row){
            this.logWin=true
            this.qryCond=' and matno=\''+row.MATNO+'\''
        },
        qtyPrc(row,index,key){
            if (key=='TAXPRC'|| key=='ACTQTY' ){
                if (row['ACTQTY'] && row['TAXPRC']) 
                row['AMT'] = (Number(row['ACTQTY'])*Number( row['TAXPRC'])).toFixed(2)      
            }
        },
 
        inputBtn(row,index){
            this.v_table ='V_IC_STKLOG'
            this.tableCol =this.logCol
            this.v_tabIndex=index
            this.v_key2=''
            this.v_value2=''
            this.v_tabRow=JSON.parse(JSON.stringify(row))
            this.t_cond=' and qty>0'
            this.btnWin=true
        },
        refSent(){
            this.v_table ='V_ORD_SENTQRY'
            this.tableCol =this.sentCol
            this.v_cond=' and stfg=\'Y\''
            this.saleWin=true
        },
        //客户选择
        orgChoose(){
            this.cltWin=true
        },
 
        //出库明细 
        getDtlList(idseq ){
            this.v_loading =true
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_IC_STKDTL_QRY','idseq',idseq,'','','','','' ).then((res) => { 
                this.dtlData =res.result 
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                    this.v_loading =false
                })  
            })
 
        },
        //选择产品
        prdChoose(){
            if(this.dtlRow['MATTY']==='PRD'){
                this.selPrdWin=true
            }else{
                this.matWin=true
            }
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'124',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        prdSel(row){
            this.dtlRow['MATNO']=row['MATNO']
            this.dtlRow['MATNM']=row['MATNM']
            this.dtlRow['MATTYNM']=row['MATTYNM']
            this.dtlRow['MODELNM']=row['MODELNM']
            this.dtlRow['MATDESC']=row['MATDESC']
            this.selPrdWin=false
        },
        matSure(row){
            this.dtlRow['MATNO']=row['MATNO']
            this.dtlRow['MATNM']=row['MATNM']
            this.dtlRow['MATDESC']=row['MATDESC']
            this.dtlRow['UNITNM']=row['UNITNM']
            this.matWin=false
        },
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
        cpRec(row,index){
          
            let v_obj ={IDSEQ:'',LSTSEQ:'',MATNO:row['MATNO'],POQTY:row['POQTY'],ACTQTY:row['ACTQTY'],STKNO:row['STKNO'], UNITNM:row['UNITNM'],
                        TAX:row['TAX'],TAXPRC:row['TAXPRC'],REFIDNO:row['REFIDNO'], REFIDSEQ:row['REFIDSEQ'], REFLSTSEQ:row['REFLSTSEQ'],OUTIDSEQ:row['OUTIDSEQ'],OUTLSTSEQ:row['OUTLSTSEQ'],
                        BOMNUM:row['BOMNUM'],BOMUNITNM:row['BOMUNITNM'],FLAG:row['FLAG'],OUTQTY:row['OUTQTY'], OUTNO:row['OUTNO'] ,STFG:'C' }
            this.dtlData.splice(index+1,0,v_obj)  //在其下方插入一行
        },
  
        //子件供应商选择
        sup_Selrec(){
            this.cltWin=true
        },
        clntSel(idseq,val){
            this.formRow['CLNTNO']=idseq
            this.formRow['CLNTNM']=val
            this.cltWin=false
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.formRow =JSON.parse(JSON.stringify(row))
            //出库明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true   
            this.v_commit =true      
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit){
                let amt_=0 , v_title='' 
                //汇总明细金额
                this.dtlData.forEach(item => {
                   if (item['AMT']){
                     amt_ =Number(amt_)+Number(item.AMT)
                   }
                   this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                       if (!item[it.key]){
                           v_title =it['title']
                           return true
                       }
                   }) 
                }) 
                let v_arr  = Array.from(new Set(this.dtlData.map(item=>item.CLNTNM)) )
                if (v_title){
                    this.promptWin =true
                    this.prompt =v_title +'不能为空'
                }else if (v_arr.length>1){
                    this.promptWin =true
                    this.prompt ='明细中不能有多个客户'
                }else{
                    this.v_commit =false
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.formRow,{CORPID:this.v_corpid,AMT:amt_.toFixed(2)})), p_table:'IC_STK',frmid:'124'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、出库明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'IC_STKDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }else{
                                    this.getStkList('')
                                }
                            })
                            //出库明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'IC_STKdtl', p_action:'D' },
                                })
                            }  
                            this.addWin =false     
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    })  
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.formRow={ICDTTM:getDate('day'),IDSEQ:'',IDTY:'SALEOUT',STKNO:'15412'}
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true   
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        //状态变更
        stfgRec(row,val,index){
            getTabColOrData(this.v_url,'V_IC_STKDTL_QRY','idseq',row['IDSEQ'],'','','','','' ).then((res) => { 
                if (res.result.length==0 ){
                    this.promptWin =true
                    this.prompt ='明细记录为空不能操作'
                }else{           
                    let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
                    if (val==='Y'){
                        v_comm='审核'
                    }else if (val==='N'){
                        v_comm='弃审'
                    }else if (val==='X'){
                        v_comm='作废'
                    }
                    if (val=='Y'){
                        v_chkuser =this.v_usernm
                        v_chkdttm=getDate('full')
                        v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                    }else{
                        v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
                    }
                    this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        type:'info',
                    }).then(()=>{
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STK',p_cond: v_cond},
                        }).then(res=>{      
                            if(res.code =='200')  { 
                                if (val=='X'){
                                    this.outData.splice(index,1)
                                }else{           
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                                }
                            }else{
                                const errorMsg =res.result
                                const startIndex = errorMsg.indexOf("ORA-20001:") 
                                const endIndex = errorMsg.indexOf("请核查") +3
                                const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                                if (startIndex>0){
                                    this.prompt =extractedValue
                                }else{
                                    this.prompt =res.result
                                }
                                this.promptWin =true
                            }        
                        })
                    }).catch(()=>{})
                }
            })
        },
 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.outData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.outData = this.allList          
            }else{
       
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.outData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            
        },
 
        // 
        getStkList(cond){
            let vm =this
            this.t_loading=true
            getTabColOrData(this.v_url,'V_IC_STK_SALEOUT','IDTY','SALEOUT','CORPID',this.v_corpid,'','',cond+' order by '+this.selparam+' desc' ).then((res) => { 
                this.allList =res.result 
                this.initPage() 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refstk.doLayout()
                    this.t_loading=false
                }) 
            })
        },
 
        //报价商品 
        getMatList(idseq){
            getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq,'','','','','' ).then((res) => { 
                this.matData =res.result 
                if (res.length>0){
                    this.$refs['refmat'].setCurrentRow(res.result[0])
                }else{
                    this.prcData=[]
                }
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','124','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','124','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','124','lstseq','6','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.logCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','470845','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.sentCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
